import type { ReactNode } from 'react';

interface ForProps<T> {
  each: T[];
  renderItem: (item: T, index: number) => ReactNode;
}

export const For = <T,>({ each, renderItem }: ForProps<T>): ReactNode => {
  // eslint-disable-next-line local/no-jsx-map
  return <>{each.map((item, index) => renderItem(item, index))}</>;
};
